import React from "react";

const TermsAndCondition = () => {
  return (
    <div className="w-full bg-white px-4 md:px-8 lg:px-10 py-16">
      {/* PAGE TITLE */}
      <div className="text-center mb-14">
        <span
          className="text-xs font-medium tracking-widest uppercase"
          style={{ color: "#c020d0", letterSpacing: "0.2em" }}
        >
          [GENERAL TERMS AND CONDITION]
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl text-[#041122] font-heading font-semibold mt-4">
          Explore General Terms and Condition
        </h1>
      </div>

      <div className="space-y-10 text-[#041122] leading-8 text-base md:text-lg">
        {/* SECTION 1 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Mix master RMC's scope of work shall include
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Study & recommendation of concrete mix design conforming to IS
              456:2000
            </li>
            <li>
              Entire quantity of concrete in a transit mixer shall be used by
              the client within 45 minutes of its reaching at site. Further
              delay may deteriorate quality of concrete.
            </li>
            <li>Pouring of concrete at site as required by the client.</li>
            <li>
              MM shall not be responsible for any problems in the finished
              concrete arising due to improper and inadequate workmanship in
              placing compacting, and curing of concrete.
            </li>
          </ul>
        </div>

        {/* SECTION 2 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Taxes, Duties & Levies
          </h2>
          <p>
            The rates are based on the prevailing taxes, duties and levies
            applicable on Ready-mix concrete in the state of Odisha. Any changes
            in the same shall be applicable at the rates as per actual.
          </p>
        </div>

        {/* SECTION 3 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Accounts Confirmation</h2>
          <p>
            MM shall submit a statement of account to the client every month for
            confirming quantities of concrete supplied, outstanding dues and
            payments received electronically through email &/or whatsapp. The
            client shall sign and return copy of the same within 7 days of
            receiving the same failing which it shall be assumed that the
            statement of accounts holds well with the client. No further
            disputes on the same shall be entertained by MM at a later date and
            outstanding dues in the statement of accounts shall thereby be
            considered as binding on the client.
          </p>
        </div>

        {/* SECTION 4 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Delay in Payments</h2>
          <p>
            Bills of concrete supplied at your site shall be payable by you as
            per mutually agreed terms. Any outstanding for more than 15 days
            beyond the agreed period shall attract an interest @ 24% P.A.
            payable monthly, till the time principal amount is paid.
          </p>
        </div>

        {/* SECTION 5 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Mode of Measurement</h2>
          <p>
            Measurement shall be based on volume of concrete delivered at site
            as per our delivery challans. Claims on discrepancy of concrete
            quantity noted by the client, if any, should be reported to MM
            during or immediately after the pour of concrete. The same shall be
            attended within the next 24 hours by MM’s representative. A joint
            statement shall be issued stating the outcome, signed by
            representatives of both MM and the client. If discrepancy in
            concrete quantities is not intimated to MM within 24 hours of the
            pour, MM shall not be held responsible for the same.
          </p>
        </div>

        {/* SECTION 6 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Client’s Responsibility
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Providing sturdy shuttering, cantering and reinforcement grid
              complete with firm concrete cover. The client shall take care that
              the shuttering/formwork do not undergo buckling/deformation during
              pouring.
            </li>
            <li>
              Providing regular construction practices at site including
              sufficient manpower and equipment to place, compact and finish
              concrete.
            </li>
            <li>
              Client shall also follow the curing practices recommended in IS
              456:2000.
            </li>
            <li>
              Please instruct concrete user that, to avoid any risk of serious
              skin injury, they should minimize contact with wet concrete. To
              avoid direct contact with wet concrete use suitable clothing and
              PPE.
            </li>
          </ul>
        </div>

        {/* SECTION 7 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Testing Of Concrete</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Testing of concrete whether by MM or by the client shall be
              strictly in accordance with the norms laid down in pertinent BIS
              codes.
            </li>
            <li>
              Testing of cubes shall be done in accordance with IS: 516 in a
              laboratory accredited under BIS.
            </li>
            <li>
              Samples shall be taken in accordance with guidelines laid down in
              IS: 1199.
            </li>
          </ul>

          <p className="mt-4">
            MM shall not be held responsible for the compressive strength of
            concrete cubes if the same has been cast by adding other materials
            without prior written consent of MM and not conforming to
            specifications laid by IS: 1199.
          </p>

          <p className="mt-4">
            In the event of failure of concrete cubes after 28 days,
            non-destructive testing methods shall be adopted to verify the
            strength of concrete. If the results of such test reveal
            inadequacies in strength of concrete done by MM, then opinion of the
            structural consultant shall be sought. In such scenario, MM shall
            have the right to seek opinion of an external structural consultant,
            if necessary.
          </p>

          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>I. Cubes shall be cast in accordance with BIS standards;</li>
            <li>II. Laboratory shall be accredited under BIS;</li>
            <li>
              III. At least three cubes from the same lot shall be given to MM
              for verifying the strength in MM’s laboratory;
            </li>
            <li>
              IV. In case of discrepancy in results of cube test noted by the
              client, same shall be communicated to MM in writing, within
              twenty-four hours of such finding.
            </li>
          </ul>
        </div>

        {/* SECTION 8 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Transit Mixer Detention & Part Load
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Any detention every 15 minutes additional charge @Rs. 50/- per Cum
              levied from customer.
            </li>
            <li>
              In any case, if the concrete is consumed at site after 1 hour
              reaching at site, MM shall not be responsible for quality of the
              same.
            </li>
            <li>
              Concrete shall generally be ordered by client in multiples of 8 or
              11 Cum.
            </li>
            <li>
              Part loads of concrete in a transit mixer shall be charged extra.
            </li>
          </ul>
        </div>

        {/* SECTION 9 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Access to Site</h2>
          <p>
            Client shall provide proper access road at work site for transit
            mixers, pumps and related equipment. Necessary permission/gate pass
            for MM’s persons, vehicles and equipment, if required, shall be
            arranged by the client.
          </p>
        </div>

        {/* SECTION 10 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Supply in Traffic Restricted Area
          </h2>
          <p>
            The required concrete is during traffic restrictions times or area;
            the supply shall be done only with the permission from concerned
            authority obtained by you. Any penalty if incurred on this count
            will be to your account.
          </p>
        </div>

        {/* SECTION 11 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Force Majeure</h2>
          <p>
            If the performance of obligations under this contract is prevented,
            restricted or interfered with by reason of any contingency, which
            could not have been reasonably avoided, the party so affected shall
            not be liable to the other for damages to the extent of such
            prevention, restriction or interference. Such contingency shall
            include but will not be limited to power cuts, equipment failures,
            lock outs, strikes or other concerted acts of workmen,
            non-availability of and/or delayed transport, breakdown of
            machinery, non-availability of raw material, fire, flood,
            earthquake, explosion, riots, acts of God, acts of Government,
            Government Regulations, war whether declared or not, or enemy
            action. The obligations to perform during the period of this
            contract shall arise again immediately upon termination of the
            contingency or such moderation of the contingency, so that
            performance is no longer prevented, restricted or interfered with.
          </p>
        </div>

        {/* SECTION 12 */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">Warranty Disclaimer</h2>
          <p>
            MM warrants that the products identified are in accordance with
            appropriate BIS specification will not be responsible for any kind
            of modifications or addition to this warranty, MM makes no warranty
            or representation, either expressed or implied with respect to this
            product and disclaims any implied warranty of merchantability or
            fitness for a particular purpose.
          </p>

          <p className="mt-4">
            As MM has no control over other ingredients mixed / used with this
            product on final application. The ingredients mentioned in our trial
            mix alone shall come under our purview.
          </p>

          <p className="mt-4">
            In no event shall MM liable for direct, indirect, special,
            incidental or consequential damages arising out of the use of this
            product, even if advised of the possibility of such damages.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
